import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import sendRequest, { sendPost, sendPut, sendDelete } from 'util/request';
import { getParams, GUIDChecker, nNU, showToast, formatDate } from 'util/utils';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';

const headers = [
	string.APP_SC_USAGE_TYPE,//'TYPE',
	string.APP_SC_USAGE_NAME,//'NAME',
	string.APP_SC_USAGE_VOL,//'VOLUME',
	string.APP_SC_USAGE_ASSIGNED_AT,//'ASSIGNED AT',
	string.APP_SC_USAGE_PROCESSED_AT,//'PROCESSED AT',
	string.APP_SC_USAGE_PROCESSED_RESULT,//'PROCESSED RESULT',
];

const ServiceCodeUsage = ({ serviceCodeId = null }) => {
	//-------------------------------HOOKS-------------------------------------------------------------
	const params = getParams();
	const serviceId = serviceCodeId || params?.id;
	const currentUser = useSelector(selectCurrentUser);
	const isAdmin = useMemo(
		() => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
		[ currentUser.accountRole ]
	);
	const isMonitorOnly = useMemo(
		() => currentUser.isMonitorOnly === 1,
		[currentUser.isMonitorOnly]
	);
	const [ page, setPage ] = useState(1);
	const [ total, setTotal ] = useState(0);
	const [ pageSize, setPageSize ] = useState(10);
	const [serviceCodeConfigs, setServiceCodeConfigs] = useState([]);
	const [ searchId, setSearchId ] = useState('');
	const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);

	//------------------------------FUNCTIONS----------------------------------------------------------
	const doSearch = useCallback(
		async (page, pageSize, searchKeyword, getAll = false) => {
			// let data = isAdmin ?
			// 	await sendPost({
			// 		url: Urls.servicecode.list,
			// 		body: {
			// 			offset: (page - 1) * pageSize,
			// 			size: pageSize,
			// 			keyword: searchKeyword,
			// 		},
			// 	}):
			// 	await sendRequest({
			// 		url: `${Urls.servicecode.config}/${serviceId}`,
			// 		method: 'GET',
			// 	});
			let data = 	await sendRequest({
				url: `${Urls.servicecode.config}/${serviceId}`,
				method: 'GET',
			});
			const { total, result } = data;
			if (!getAll) {
				setServiceCodeConfigs(result);
				// console.log(result)
				setTotal(total);
			}
			return result;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[ ]
	);
	useEffect(() => {
		doSearch(page, pageSize, debouncedSearchId);
	}, [ page, pageSize, debouncedSearchId, doSearch]);

	const dataTable = useCallback(
		(data) => data.map((raw,key)=>({
			key: raw.id,
			data:[
				(raw?.pocId > 0) ? string.APP_SC_USAGE_TYPE_APP_ID : string.APP_SC_USAGE_TYPE_CHANNEL,
				(raw?.pocId > 0) ? raw?.displayName : raw?.groupName,
				raw?.volume,
				formatDate(raw?.assignedAt, 'YYYY/MM/DD'),
				nNU(raw?.processedAt) ? formatDate(raw?.processedAt, 'YYYY/MM/DD') : "-",
				!nNU(raw?.processedAt) ? "-" :
				 (raw?.status === 1) ? "正常完了" : "無効"
			],
			raw,
		})),[]
	);
	//-------------------------------RETURN------------------------------------------------------------
	return(
		<>
			<Page
				title={''}
				body={
					<>
						<Table
							className="nowrap"
							page={page}
							pageSize={pageSize}
							total={total}
							onPageChanged={setPage}
							onPageSizeChanged={setPageSize}
							headers={headers}
							data={dataTable(serviceCodeConfigs)}
							isPaging = {false}
						/>
					</>
				}
			/>
		</>
	);
};

export default ServiceCodeUsage;